import $ from 'jquery';

// carrierwave の extension_allowlist / content_type_allowlist はダイレクトアップロードでは通らないので、
// ここでも同じ制限をかける。app/controllers/concerns/direct_video_upload.rb と揃えること。
// ただしJS側は開発者ツールで回避できるため、本質的な制限はサーバー側 (署名の発行時) で行っている。
const ALLOWED_EXTENSIONS = ['mp4', 'mov'];
const ALLOWED_CONTENT_TYPES = ['video/mp4', 'video/quicktime'];
const DISALLOWED_FILE_MESSAGE = 'アップロードできるのはmp4またはmov形式の動画ファイルのみです。';
// app/lib/aws_direct_uploader.rb の MAX_UPLOAD_SIZE と揃えること。
// 署名付きURLの content-length-range にも同じ上限が入っているので、
// ここを回避しても S3 側で弾かれる (ここは長時間アップロードしてから失敗するのを防ぐためのもの)。
const MAX_UPLOAD_SIZE = 5 * 1024 * 1024 * 1024;
const TOO_LARGE_FILE_MESSAGE = 'アップロードできる動画のサイズは5GBまでです。';

const allowedExtension = (fileName) => {
  const matched = /\.([^.]+)$/.exec(fileName || '');

  return matched !== null && ALLOWED_EXTENSIONS.includes(matched[1].toLowerCase());
};

const allowedFile = (file) => allowedExtension(file.name) && ALLOWED_CONTENT_TYPES.includes(file.type);

export default(url) => {
  const $videoForm = $('.js-direct-upload-video-file-form');
  const $fileInput = $('.js-video-file-input');
  const $submitButton = $('.js-submit-video');
  const $uploadProgress = $('.js-upload-progress');
  const $errorMessage = $('.js-error-message');

  // アップロードをやり直すときに、前回選んだファイルのキーが残らないようにする
  const clearUploadedVideo = () => {
    $videoForm.find('input[name="direct_uploaded_video"]').remove();
  };

  // アップロード前の状態に戻す。選んだファイルのキー・進捗の文言・送信ボタンの無効化を解除する
  const resetUploadState = () => {
    clearUploadedVideo();
    $uploadProgress.text('');
    $submitButton.prop('disabled', false);
    $submitButton.removeClass('is-loading');
  };

  const abortUpload = (message) => {
    resetUploadState();
    $fileInput.val('');
    $errorMessage.text(message);
    $('html, body').animate({ scrollTop: 0 });
  };

  const directUploadWithPresignedPost = (e) => {
    const file = e.target.files[0];

    // ファイルの選択が空になったとき。以前はここで何もせずに抜けていたため、
    // 「現在動画をアップロード準備中です。」の表示と送信ボタンの無効化が残り、
    // さらに前回アップロードした direct_uploaded_video がフォームに残ったままになっていた
    // (そのまま送信すると、選択を外したはずの動画が登録されてしまう)。
    // @see https://github.com/exestinc/video_db/issues/2037
    if (!file) {
      resetUploadState();
      $errorMessage.text('');
      return;
    }

    // accept: 'video/*' はファイル選択ダイアログのフィルタでしかなく、
    // 「すべてのファイル」を選べば回避できるのでここで弾く
    if (!allowedFile(file)) {
      abortUpload(DISALLOWED_FILE_MESSAGE);
      return;
    }

    if (file.size > MAX_UPLOAD_SIZE) {
      abortUpload(TOO_LARGE_FILE_MESSAGE);
      return;
    }

    clearUploadedVideo();
    $errorMessage.text('');
    $submitButton.prop('disabled', true);
    $submitButton.addClass('is-loading');
    $uploadProgress.text('現在動画をアップロード準備中です。');

    $.ajax({
      url: `${url}`,
      type: 'POST',
      dataType: 'json',
      data: {
        size: file.size,
        content_type: file.type,
        file_name: file.name
      },
      beforeSend: (xhr) => {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      }
    }).then((data) => {
      let name, fd = new FormData();
      for (name in data.fields) if (data.fields.hasOwnProperty(name)) {
        fd.append(name, data.fields[name]);
      }
      fd.append('file', file); // ファイルを添付

      const xhr = new XMLHttpRequest();
      xhr.open('post', data.url, true);
      xhr.onreadystatechange = (aEvt) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 201) {
            const input = $('<input />', { type: 'hidden', name: 'direct_uploaded_video', value: data.upload_file_name });
            $videoForm.append(input);

            $submitButton.prop('disabled', false);
            $submitButton.removeClass('is-loading');
            $uploadProgress.text('動画のアップロード準備が完了しました。');
          } else {
            abortUpload('動画のアップロードに失敗しました。時間をおいて再度お試しください。');
          }
        }
      };
      xhr.send(fd);
    }).catch((res) => {
      // 署名の発行がサーバー側で拒否された場合 (許可していない拡張子・Content-Type など)
      const error = res.responseJSON && res.responseJSON.error;
      abortUpload(error || '動画のアップロード準備に失敗しました。時間をおいて再度お試しください。');
    });
  };

  $fileInput.on('change', (e) => {
    directUploadWithPresignedPost(e);
  });

  $videoForm.on('submit', () => {
    // ActionDispatch::Http::UploadedFile の情報がparamsに入らないようにしている
    $fileInput.prop('disabled', true)
    $submitButton.prop('disabled', true);

    const form = $videoForm[0];
    const formData = new FormData(form);

    $.ajax({
      url: $videoForm.attr('action'),
      type: $videoForm.attr('method'),
      data: formData,
      processData: false,
      contentType: false
    }).then()
      .catch((res) => {
        $errorMessage.text(res.responseText);
        $submitButton.prop('disabled', false);
        $submitButton.removeClass('is-loading');
        $fileInput.prop('disabled', false);
        $('html, body').animate({ scrollTop: 0 });
      });

    return false;
  })
}
